/**
 * Quarry Entry Gate API client.
 *
 * Mirrors the CSRF + $.ajax wrapper pattern used in ../ajax.js (kept
 * self-contained here rather than editing ajax.js, per the frontend
 * file-ownership rules for this feature).
 *
 * Endpoints consumed (frozen contract, scope-portal §3):
 *   GET    /api/quarry/job-log/
 *   GET    /api/quarry/jobs/<job_id>/entries/
 *   POST   /api/quarry/jobs/<job_id>/entries/
 *   POST   /api/quarry/jobs/<job_id>/trucks/
 *   DELETE /api/quarry/entries/<entry_id>/
 */
export default class QuarryApi {
	static async ajaxCall(url, type, data, context) {
		let body;
		let status;
		let error;
		const dataType = 'json';

		try {
			body = await $.ajax({
				context,
				url,
				type,
				data: data ? JSON.stringify(data) : null,
				dataType,
				contentType: 'application/json; charset=UTF-8',
				beforeSend: (xhr) => {
					if (type === 'post' || type === 'patch' || type === 'delete') {
						xhr.setRequestHeader('X-CSRFToken', $('[name=csrfmiddlewaretoken]').val());
					}
				}
			});
		} catch (e) {
			error = e;
			status = e && e.status;
			body = e && e.responseJSON;
		}

		return {
			body,
			status,
			error
		};
	}

	static async getJobLog(facility, date, context) {
		const params = [];

		if (facility) {
			params.push(`facility=${encodeURIComponent(facility)}`);
		}

		if (date) {
			params.push(`date=${encodeURIComponent(date)}`);
		}

		const query = params.length ? `?${params.join('&')}` : '';
		const url = `/api/quarry/job-log/${query}`;

		return this.ajaxCall(url, 'get', null, context);
	}

	static async getJobEntries(jobId, context) {
		const url = `/api/quarry/jobs/${jobId}/entries/`;

		return this.ajaxCall(url, 'get', null, context);
	}

	static async createEntry(jobId, data, context) {
		const url = `/api/quarry/jobs/${jobId}/entries/`;

		return this.ajaxCall(url, 'post', data, context);
	}

	static async addTruck(jobId, data, context) {
		const url = `/api/quarry/jobs/${jobId}/trucks/`;

		return this.ajaxCall(url, 'post', data, context);
	}

	static async deleteEntry(entryId, context) {
		const url = `/api/quarry/entries/${entryId}/`;

		return this.ajaxCall(url, 'delete', null, context);
	}
}
